import { render } from "./FormButton.vue?vue&type=template&id=a511a1b6"
import script from "./FormButton.vue?vue&type=script&lang=js"
export * from "./FormButton.vue?vue&type=script&lang=js"
script.render = render

export default script